<template>
  <div class="header-wrap">
    <header>
      <div class="header-left">
        <div class="logo">?</div>
        <!-- <img style="width: 200px" src="../assets/companyLogo.png" /> -->
        <div class="helptitle">帮助中心</div>
      </div>
      <div class="header-right">
        <!-- <div class="msg" style="margin-left: 19px">
          <img src="@/assets/msgicon.png" alt="" />
          <span>消息</span>
        </div> -->
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            {{ this.orgInfo.orgName|limitWords(10)
                        }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-office-building" @click.native="tootherindex">企业中心</el-dropdown-item>
            <el-dropdown-item @click.native="logout" icon="el-icon-switch-button">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="line"></div>
        <div class="msg" @click="tohelpcenter">
          <img src="@/assets/help.png" alt="" />
          <span>帮助</span>
        </div>
        <div class="line"></div>
        <apps></apps>
      </div>
    </header>
  </div>
</template>

<script>
import Cookie from 'js-cookie';

import apps from './apps';

export default {
  components: {
    apps,
  },
  created () {
    this.getUserInfo()
  },
  data () {
    return {
      userInfo: [],
      orgInfo: []
    }
  },
  methods: {
    getUserInfo () {
      this.$http.get('authority-center/common/user/info').then((res) => {
        this.orgInfo = res.data
        this.$http.get(`authority-center/org/${res.data.orgId}`).then((res) => {
          this.userInfo = res.data
        })
      })
    },
    toindex () {
      this.$router.push('index')
    },
    tootherindex() {
      // window.location.href = 'http://ucenter.prosuntech.com/#/enterpriseIndex';
      window.location.href = 'https://ucenter.joyousoa.com/#/enterpriseIndex';
    },
    tohelpcenter () {
      window.open('https://help.joyousoa.com/')
    },
    linktojoyousoa () {
      this.$router.push('/index')
    },
    linktosms () {
      this.$router.push('/smsindex')
    },
    logout () {
      window.sessionStorage.removeItem('token')
      Cookie.remove('token', { path: '/', domain: '192.168.18.199' });
      Cookie.remove("token", { path: "/", domain: ".prosuntech.com" });
      Cookie.remove('token', { path: '/', domain: '.joyousoa.com' });
      this.$router.push('/login')
      window.location.reload()
    },
  },
}
</script>

<style lang="less" scoped>
.header-wrap {
  border-bottom: 1px solid rgba(204, 204, 204, 0.3);

  header {
    width: 97%;
    height: 60px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      justify-content: left;

      .logo {
        width: 40px;
        height: 40px;
        background: #f1b619;
        border-radius: 8px;
        font-size: 30px;
        color: #fff;
        font-weight: 700;
        line-height: 40px;
        text-align: center;
        margin-right: 8px;
      }

      .helptitle {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 33px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: left;

      .otherapp {
        width: 80px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          height: 14px;
        }

        span {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.7);
          line-height: 24px;
          margin-left: 8px;
        }
      }

      .company-name {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0a1629;
        line-height: 24px;
      }

      .line {
        width: 5px;
        transform: scaleX(0.2);
        // border-right: 1px solid #000;
        height: 24px;
        background: #000;
        opacity: 0.1;
        margin: 0 15px;
      }

      .el-dropdown-link {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0a1629;
        line-height: 24px;
      }

      .msg {
        display: flex;
        align-items: center;
        justify-content: left;
        cursor: pointer;

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0a1629;
          line-height: 24px;
          margin-left: 9px;
        }

        img {
          height: 17px;
        }
      }
    }
  }
}

.apps {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-wrap: wrap;
  cursor: pointer;

  .appitem {
    width: 66px;
    height: 66px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;

    img {
      width: 50%;
    }

    .appname {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
      line-height: 17px;
      text-shadow: 0px 0px 4px rgba(204, 204, 204, 0.5);
      margin-top: 5px;
    }
  }
}

/deep/.el-dropdown-link {
  cursor: pointer !important;
}

/deep/.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background: #fafafc;
  color: #606266 !important;
}

/deep/.el-dropdown-menu li:hover {
  color: #606266 !important;
}</style>
